export const __FIELD_NAME_INVOICE_RECEPT__ = "invoiceReceipt";
export const __FIELD_NAME_WARRANTY_CARD__ = "warrantyCard";
export const __FIELD_NAME_USER_PANEL__ = "user";
export const __FIELD_NAME_PRODUCT_PANEL__ = "product";
export const __FIELD_NAME_PANEL__ = "panel";
export const __FIELD_PRIVACY_POLCY__ = "privacyPolicy";
export const __FIELD_MARKETING_OPT_IN__ = "marketingOptIn";
export const __FIELD_OPT_IN__ = "optIn";

